import { ResourceObject } from '../api_primitives'

export interface OrganizationResource extends ResourceObject {
  type: 'Organization'
  contactEmail?: string
  contactPhoneNumber?: string
  name?: string
}
